module.exports = __webpack_public_path__ + "static/media/getStartedImage.16a097ae.png";